// useInterruptionGate.js — P11 item 10: shared suppression across every
// popup-style interruption (currently just ContactInfoModal, plus any
// future one). Two independent components both wanting to fire "first" is
// exactly how a visitor ends up interrupted twice — claim() is a single
// atomic sessionStorage slot so whichever mechanism's conditions are met
// first wins, and the other one silently loses for the rest of the tab's
// session. WhatsAppWidget is NOT gated by this — it's a persistent
// affordance, not an interruption (see App.js/FloatingActions).
const SESSION_KEY = 've_interruption_claimed';

/** True if a field the visitor is actively typing into would be yanked
 * of focus by an interruption grabbing it (a modal's focus trap steals
 * focus the instant it opens) — checked at claim time, not just at the
 * original 10s-timer mount time, so it still protects a form the visitor
 * started filling out after arrival. */
export function isFormFieldFocused() {
  const active = document.activeElement;
  return Boolean(active && ['INPUT', 'TEXTAREA', 'SELECT'].includes(active.tagName));
}

/** Attempts to claim the single per-session interruption slot. Returns
 * true (and marks it claimed) only the first time it's called in a given
 * tab session; every subsequent call — from this component or any other
 * using the same gate — returns false. */
export function claimInterruptionSlot() {
  if (typeof window === 'undefined') return false;
  if (sessionStorage.getItem(SESSION_KEY)) return false;
  if (isFormFieldFocused()) return false;
  sessionStorage.setItem(SESSION_KEY, '1');
  return true;
}

export function interruptionSlotTaken() {
  return typeof window !== 'undefined' && Boolean(sessionStorage.getItem(SESSION_KEY));
}
